/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServizioMensaReportIntestazioneDTO } from './servizio-mensa-report-intestazione-dto';
import { ServizioMensaRendicontazioneDTO } from './servizio-mensa-rendicontazione-dto';


export interface ServizioMensaRendicontazioneReportRowDTO { 
    rendicontazione?: ServizioMensaRendicontazioneDTO;
    intestazione?: ServizioMensaReportIntestazioneDTO;
}

